module.exports = __webpack_public_path__ + "static/media/up.71bcc517.svg";